module.exports = __webpack_public_path__ + "img/bottone-partecipa.7a62b25c.jpg";